<xi-drawer
  #drawer
  [open]="open()"
  [interceptClose]="false"
  (onClose)="cancel()"
  [silverBg]="true"
  color="orca"
  *transloco="let t; read: 'configuration-settings-drawer-component'"
>
  <div slot="title">{{ t('header') }}</div>

  <div slot="body">
    <xi-horizontal-tab-bar
      [data]="configSettingsTabs"
      [(activeTabId)]="activeTab"
      [hasTransparentBackground]="true"
      color="CX"
    ></xi-horizontal-tab-bar>
    <div class="config-settings-drawer__tab-bar-keyline"></div>

    <div
      [ngClass]="
        activeTab === 'general'
          ? 'config-settings-drawer--tab-visible'
          : 'config-settings-drawer--tab-hidden'
      "
    >
      <app-configuration-general
        [origConfiguration]="configuration()"
        [origVisibilityOptions]="visibilityOptions()"
        [isReadOnly]="isReadOnly()"
        (formChange)="onFormChange($event)"
        (validityChange)="isValid = $event"
      >
      </app-configuration-general>

      <app-configuration-overview
        [configuration]="configuration()"
        [templateConfiguration]="templateConfiguration()"
        [industryPacks]="industryPacks()"
        [languageTemplates]="languageTemplates()"
      ></app-configuration-overview>
    </div>

    <div
      [ngClass]="
        activeTab === 'settings'
          ? 'config-settings-drawer--tab-visible'
          : 'config-settings-drawer--tab-hidden'
      "
    >
      <app-configuration-settings
        [configuration]="configuration()"
        [summaryLimit]="summaryLimit()"
        [isReadOnly]="isReadOnly()"
        [hasAutoAnalysis]="hasAutoAnalysis()"
        (configurationChange)="onConfigurationChange($event)"
      >
      </app-configuration-settings>
    </div>
  </div>

  <div slot="footer">
    @if (hasChanges) {
      <div class="config-settings-drawer__save-bar">
        <xi-default-button
          text="{{ t('cancel') }}"
          fill="text"
          (onClick)="cancel()"
        ></xi-default-button>
        <div class="xi-loader-button-container">
          <div>
            <xi-default-button
              [disabled]="!isValid || isSaving"
              text="{{ t('save-exit') }}"
              (onClick)="save()"
            >
            </xi-default-button>
          </div>
          @if (isSaving) {
            <div class="xi-loader-container__inline-overlay">
              <xi-animation
                [height]="75"
                [width]="75"
                [loop]="true"
                animation="cx_loader"
              ></xi-animation>
            </div>
          }
        </div>
      </div>
    }
  </div>
</xi-drawer>
